import moment from '../plugins/moment';

const isValidResultsQuery = (query) => {
  const date = moment(query.fecha, 'DD-MM-YYYY');

  if (date.isValid()) {
    return query.adults && query.babies != undefined && query.childs != undefined;
  } else {
    return false;
  }
}

export default isValidResultsQuery;

